import React from 'react';

import '../sass/tracking.scss';
import './datadog';

import configureStore from './store/configureStore.prod';
import parseTrackingPageUrl from './support/parseTrackingPageUrl';
import { fetchTrackingPageSettings } from './actions/settings';
import renderOrangeTrackingPage from './renderOrangeTrackingPage';

(async () => {
  const store = configureStore();

  const { trackingPageId } = parseTrackingPageUrl(window.location.pathname);
  await store.dispatch(fetchTrackingPageSettings(trackingPageId));

  renderOrangeTrackingPage(process.env.APP_MOUNT_ID, store);
})();



// WEBPACK FOOTER //
// ./src/js/orange-tracking.js